import { render, staticRenderFns } from "./PurchaserForm.vue?vue&type=template&id=3112fc51&"
import script from "./PurchaserForm.vue?vue&type=script&lang=js&"
export * from "./PurchaserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports